import React, { useEffect, useState } from 'react'
import "../css/TopButton.css"
import { duration } from '@mui/material';
import { matchRoutes, useLocation } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

const TopButton = ({ lenis, lenisStop, lenisStart, routes }) => {
    gsap.registerPlugin(ScrollToPlugin);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;
    const matchedRoutes = matchRoutes(routes, location);
    const showTopButton = location.pathname !== "/giris-yap" && location.pathname !== "/kayit-ol" && matchedRoutes[0].route.path !== "*";

    const scrollToTop = () => {
        disableScroll();
        gsap.to(window, {
            duration: 1,
            scrollTo: { y: 0 },
            ease: 'power2.inOut',
            onComplete: enableScroll, // Animasyon tamamlandığında kaydırmayı yeniden etkinleştir
        });
    };

    const disableScroll = () => {

        // Wheel (fare tekerleği) kaydırmayı engelle
        window.addEventListener('wheel', preventDefault, { passive: false });

        // Touchmove (dokunmatik kaydırma) kaydırmayı engelle
        window.addEventListener('touchmove', preventDefault, { passive: false });

        // Klavye ile kaydırmayı engelle
        window.addEventListener('keydown', preventArrowKeys);

    };

    // Scroll'u yeniden etkinleştirme fonksiyonu
    const enableScroll = () => {

        // Wheel kaydırmayı yeniden etkinleştir
        window.removeEventListener('wheel', preventDefault);

        // Touchmove kaydırmayı yeniden etkinleştir
        window.removeEventListener('touchmove', preventDefault);

        // Klavye ile kaydırmayı yeniden etkinleştir
        window.removeEventListener('keydown', preventArrowKeys);

    };

    // Default olayını engelleme fonksiyonu
    const preventDefault = (e) => {
        e.preventDefault();
    };

    // Klavye ile kaydırmayı engelleme fonksiyonu
    const preventArrowKeys = (e) => {
        // Yalnızca yukarı ve aşağı ok tuşlarını engelle
        if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(e.key)) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    if (!showTopButton) {
        return <div></div>;
    } else {
        return (
            <button className={`top-button ${scrolled ? 'scrolled' : ''}`} onClick={scrollToTop}>
                <svg class="top-svgIcon" viewBox="0 0 384 512">
                    <path
                        d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
                    ></path>
                </svg>
            </button>

        )
    }
}


export default TopButton